import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { IAvailableColumnModel, IOwnerRoomModel, IRealEstateModel, IRoomModel } from 'interfaces';
import { IRoomDiscount } from 'pages/PageApplicationNew/interfaces';

export const getOwnerRooms = (phone: string) => {
  return instance()
    .post<IOwnerRoomModel[]>('/application/ownerRooms', { phone })
    .then((response) => response.data);
};

export const getRealEstates = (data: { onlyFromMatrix?: boolean } = {}) => {
  return instance()
    .post<IRealEstateModel[]>('/dictionary/realEstates', data)
    .then((response) => response.data);
};

export const loadRealEstate = (guid: string) => {
  return instance()
    .post<IRealEstateModel>('/dictionary/realEstate', { guid })
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { onlyFromMatrix?: boolean; searchWithCity?: boolean; nameWithCity?: boolean } = {},
) => {
  return instance()
    .post<IRealEstateModel[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};

export const getRooms = (realEstateGuid: string) => {
  return instance()
    .post<IRoomModel[]>('/dictionary/rooms', { realEstateGuid })
    .then((response) => response.data);
};

export const getApplicationVisibleColumns = () => {
  return instance()
    .post<IAvailableColumnModel[]>('/application/availableColumns')
    .then((response) => response.data);
};

export const getRoomAllDiscounts = (roomGuid: string) => {
  return instance()
    .post<IRoomDiscount[]>('/roomDiscount/get', { roomGuid })
    .then((response) => response.data);
};

export const checkIfHasPublicApplications = (config?: AxiosRequestConfig) => {
  return instance()
    .get<{ hasApplicationIsPublic: boolean }>('/application/hasApplicationIsPublic', config)
    .then((response) => response.data);
};
